<template>
  <div>
    <LvDialog
      :header="currentEvent.title"
      v-model="displayBasic"
      :style="{ maxWidth: '900px', width: '100%' }"
    >
      <div class="event-details">
        <div v-if="currentEvent.extendedProps.cover">
          <img
            :src="currentEvent.extendedProps.cover"
            alt=""
            style="
              width: 100%;
              max-height: 200px;
              object-fit: cover;
              margin-bottom: 0.75rem;
            "
          />
        </div>
        <div class="event-date-wrapper">
          <LvBadge color="success" size="sm">
            {{
              new Date(currentEvent.start).toLocaleDateString("en-UK", {
                year: "numeric",
                day: "numeric",
                month: "short",
              })
            }}
          </LvBadge>
          <template v-if="currentEvent.end">
            <span> - </span>
            <LvBadge color="success" size="sm">
              {{
                new Date(currentEvent.end).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </LvBadge>
          </template>
          <span style="font-weight: 600">
            {{ getDays(currentEvent.start) }}</span
          >
        </div>
        <template v-if="currentEvent.extendedProps.location">
          <LvButton
            :label="currentEvent.extendedProps.location"
            size="sm"
            icon="light-icon-map-pin"
            rounded
            class="lv--danger"
            style="margin-bottom: 0.75rem"
            @click="openLoc(currentEvent.extendedProps.locationLink)"
          />
        </template>
        <p v-if="currentEvent.extendedProps.description">
          {{ currentEvent.extendedProps.description }}
        </p>
        <!-- <template v-if="currentEvent.extendedProps.images">
          <h4 class="event-info-heading">Photos</h4>
          <Swiper
            :pagination="{
              clickable: true,
            }"
            :navigation="true"
            :space-between="50"
            :autoHeight="true"
            :modules="modules"
          >
            <SwiperSlide v-for="(item, ind) in swiperData" :key="ind">
              <img :src="item" alt="img" />
            </SwiperSlide>
          </Swiper>
        </template> -->
      </div>
    </LvDialog>

    <div v-if="dataLoading" class="custom-loader-wrapper">
      <div class="custom-loader"></div>
    </div>
    <div v-else class="calendar-wrapper">
      <div class="container">
        <FullCalendar :options="calendarOptions">
          <template v-slot:eventContent="arg">
            {{ arg.event.title }}
          </template>
        </FullCalendar>
      </div>
    </div>
  </div>
</template>
<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";

import LvDialog from "lightvue/dialog";
import LvButton from "lightvue/button";
import LvBadge from "lightvue/badge";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";

import { convertSpecialChars, smallMedia } from "@/utils/utils";
import axios from "axios";

export default {
  components: {
    FullCalendar,
    LvDialog,
    LvButton,
    LvBadge,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      modules: [Pagination, Navigation],
      swiperData: [
        require("@/assets/images/DSC00394.jpg"),
        require("@/assets/images/DSC00409.jpg"),
        require("@/assets/images/DSC00452.jpg"),
        require("@/assets/images/DSC00548.jpg"),
      ],
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin], //, timeGridPlugin, listPlugin
        initialView: "dayGridMonth",
        headerToolbar: {
          start: "title",
          end: "prev,next",
        },
        //  ,dayGridMonth,timeGridWeek,timeGridDay,listMonth
        dayMaxEvents: 2,
        eventClick: this.handleEventClick,
        events: [
          // {
          //   title: "Field trip (Grade 1-5)",
          //   start: "2024-10-25",
          //   end: null,
          //   description:
          //     "Exploring new horizons and creating unforgettable memories on our school trip! ",
          //   location: "Safari Park",
          //   locationLink:
          //     "https://www.google.com/maps?hl=en&gl=pk&um=1&ie=UTF-8&fb=1&sa=X&ftid=0x3eb338c41059ace9:0x59f6e847f82104b2",
          //   images: "dsad",
          //   cover: require("@/assets/images/visionbg.jpeg"),
          // },
          // {
          //   title: "Cricket Tournament (Grade 6 - 10)",
          //   start: "2024-10-14",
          //   end: "2024-10-16T23:00:00",
          //   location: "The Elixir School Grond",
          // },
          // {
          //   title: "School re-opens",
          //   start: "2024-10-01",
          // },
        ],
      },
      currentEvent: {
        extendedProps: {},
      },
      displayBasic: false,
      dataLoading: false,
    };
  },
  created() {
    this.LoadData();
  },
  methods: {
    convertSpecialChars,
    smallMedia,

    openLoc(url) {
      if (url) window.open(url, "_blank");
    },
    getDays(val) {
      let currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      let valid = new Date(val);
      valid.setHours(0, 0, 0, 0);

      let diff = valid.getTime() - currentDate.getTime();
      let oneDay = 24 * 60 * 60 * 1000;

      let daysLeft = 0;
      let text = "days remaining";
      if (diff > 0) {
        daysLeft = Math.ceil(diff / oneDay);
      }
      if (daysLeft == 0) return "";
      if (daysLeft == 1) text = "day remaining";
      return `(${daysLeft} ${text})`;
    },

    handleEventClick(ev) {
      // { event: ev }
      // console.log(ev)
      this.currentEvent = ev.event;
      this.displayBasic = true;
      // console.log(this.currentEvent);
      // alert("date click! " + arg.dateStr);
    },
    LoadData() {
      this.dataLoading = true;
      let config = {
        method: "get",
        url: `${this.$store.state.domain}/calendars?populate=deep`,
        headers: {
          Authorization: this.$store.state.token,
        },
      };
      axios(config)
        .then((res) => {
          // console.log(res.data.data);
          if (res.data.data.length > 0) {
            this.calendarOptions.events = res.data.data[0].attributes.Event;
          } else this.calendarOptions.events = [];
        })
        .catch((err) => console.log(err))
        .finally(() => (this.dataLoading = false));
    },
  },
};
</script>
<style>
.fc .fc-view-harness {
  min-height: 650px;
}
.fc .fc-col-header-cell-cushion {
  color: #555;
  text-decoration: none;
  line-height: 1.4;
}
.fc .fc-col-header-cell-cushion:hover {
  color: #555;
  text-decoration: none;
}
.fc .fc-daygrid-day-number {
  color: #b9b9c3;
  cursor: pointer;
}
.fc .fc-button-group {
  gap: 1rem;
}
.fc .fc-button-primary,
.fc .fc-button-primary:not(:disabled):active {
  background-color: var(--primary);
  border-color: var(--primary);
  color: white;
  border-radius: 0.25rem !important;
}
.fc .fc-button-primary:hover {
  background-color: white;
  border-color: var(--primary);
  color: var(--primary);
}
.fc .fc-button-primary:focus {
  box-shadow: none !important;
}
.fc .fc-daygrid-day.fc-day-today {
  background-color: #f8f8f8 !important;
  /* background-color: rgba(40, 199, 111, 0.12); */
}
.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
  color: #555;
}
.fc-h-event {
  background-color: var(--primary);
  border: none;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  white-space: normal;
}
.fc .fc-daygrid-day {
  padding: 5px;
}
.fc .fc-daygrid-more-link {
  color: #444;
}

.event-details {
  padding-top: 1rem;
}
.event-date-wrapper {
  margin-bottom: 0.75rem;
}
.event-details p {
  font-size: 16px;
  line-height: 1.2;
  word-wrap: break-word;
}
.event-info-heading {
  /* margin-top: 0; */
  margin-bottom: 0.75rem;
}
:root {
  --swiper-theme-color: var(--primary);
}
/* .swiper-button-prev,
.swiper-button-next {
  color: var(--primary);
} */
</style>
<!-- <style scoped>
.swiper-slide img {
  aspect-ratio: 2;
  object-fit: contain;
}
</style> -->
